export const getIsRof = (plan: Plan) => {
  return !!plan?.is_rof;
};
